var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',[_c('home-header')],1),(_vm.isShow)?_c('el-container',[_c('home-side'),_c('el-main',[_c('router-view')],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }